import React from 'react';

import { Button, Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';

import { ICompanyCreate } from 'types/Company';
import { AccessRow } from './AccessRow';
import { useFieldArray, useFormContext } from 'react-hook-form';

const MAX_ACCESS = 5;

export const AccessForm: React.FC = () => {
  const { control } = useFormContext<ICompanyCreate>();
  const { fields, append, remove, update } = useFieldArray({
    control,
    name: 'users',
  });

  return (
    <Box>
      <Typography sx={{ fontSize: 20, fontWeight: 500 }}>
        Acessos Portal do RH
      </Typography>

      <Grid container spacing={2} mt={1}>
        {fields.map((item, index) => (
          <AccessRow
            {...item}
            key={item.id}
            index={index}
            onDeleteClick={() => {
              if (fields.length === 1) {
                return update(0, {
                  email: '',
                  name: '',
                  isSuperUser: false,
                });
              }
              remove(index);
            }}
          />
        ))}
      </Grid>

      <Box flex={1} display="flex" justifyContent="flex-end" mr={2} mt={2}>
        <Button
          disabled={fields?.length >= MAX_ACCESS}
          color="info"
          onClick={() => {
            append({
              email: '',
              name: '',
              isSuperUser: false,
            });
          }}
          type="button"
        >
          + Adicionar E-mail
        </Button>
      </Box>
    </Box>
  );
};
